// extracted by mini-css-extract-plugin
export var container = "Balloon-module--container--ICi7g";
export var white = "Balloon-module--white--08R7p";
export var yellow = "Balloon-module--yellow--ZjcHv";
export var float1 = "Balloon-module--float1--Zyin+";
export var float = "Balloon-module--float--B6sGC";